import { OtherActivitiesList } from '@shared/api/types';
import Unit from '@shared/components/content/unit';
import { HeaderCell } from '@shared/components/data-table/cells/header-cell';
import { TextCell } from '@shared/components/data-table/cells/text-cell';
import { formatSmallNumber } from '@shared/lib/utils';
import { ColumnDef } from '@tanstack/react-table';

export const additionalCategoryTableColumns: ColumnDef<OtherActivitiesList>[] =
  [
    {
      id: 'site',
      accessorKey: 'site',
      header: ({ column }) => <HeaderCell column={column} name="Site" />,
      cell: ({ getValue }) => {
        const site = getValue<OtherActivitiesList['site']>();
        return <TextCell text={site?.name || '-'} />;
      },
    },
    {
      id: 'description',
      accessorKey: 'description',
      header: ({ column }) => <HeaderCell column={column} name="Description" />,
      cell: ({ getValue }) => {
        const description = getValue<string>();
        return <TextCell text={description} />;
      },
      meta: {
        label: 'Search',
        variant: 'text',
        sorting: { ascLabel: 'A-Z', descLabel: 'Z-A' },
      },
    },
    {
      id: 'emissions',
      accessorKey: 'emissions',
      header: ({ column }) => (
        <HeaderCell
          column={column}
          name="Emissions"
          numberColumn
          unit={<Unit variant="tCO2e" />}
        />
      ),
      cell: ({ getValue }) => {
        const emissions = getValue<number>();
        return <TextCell text={formatSmallNumber(emissions)} type="number" />;
      },
    },
  ];
